import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const trialAccountData = createSelector(
    (state: any) => state.Co2Profile,
    (profileData) => ({
        isTrialAccount: !!profileData?.userBusiness?.on_trial,
        requiresLicensePurchase: !!profileData?.userBusiness?.license_purchase_required,
        hasActivePaidLicense: profileData?.userBusiness?.has_active_paid_license === true,
    })
);

/**
 * True while the business is on a free trial license (userBusiness.on_trial from the
 * profile). Trial accounts cannot buy tokens or use auto top-up; the backend enforces
 * the same rules, this only hides the related UI.
 */
export const useTrialAccount = () => useSelector(trialAccountData);
